// @flow
import React, { type Node } from 'react';

import { Button } from 'primitive-components';
import { Grid } from 'layout-core-components';

import TransactionSidebarBorderedSection from './TransactionSidebarBorderedSection';
import TransactionSidebarFooterButton from './TransactionSidebarFooterButton';
import TransactionSidebarSegmentingZeroState from './TransactionSidebarSegmentingZeroState';

type TransactionSidebarSegmentationSlideProps = {
  children: Node,
  hasSegmentCategories: boolean,
  onRequestOpenManageSegments: () => void,
  onViewEntireTransaction: Function,
  clientId: string,
};

export default function TransactionSidebarSegmentationSlide({
  children,
  hasSegmentCategories,
  onRequestOpenManageSegments,
  onViewEntireTransaction,
  clientId,
}: TransactionSidebarSegmentationSlideProps) {
  const clientsWithEnabledSegmentTracking = window?.BENCH?.clientsWithEnabledSegmentTracking || {};
  const transactionTaggingDisabled = clientsWithEnabledSegmentTracking[clientId] !== true;

  if (!hasSegmentCategories) {
    return (
      <Grid column="0 min-content auto">
        <React.Fragment>
          <TransactionSidebarBorderedSection />
          <TransactionSidebarFooterButton onViewEntireTransaction={onViewEntireTransaction} />
          <TransactionSidebarSegmentingZeroState onSetupSegmenting={onRequestOpenManageSegments} />
        </React.Fragment>
      </Grid>
    );
  }
  return (
    <Grid column="0 min-content auto 56px">
      <React.Fragment>
        <TransactionSidebarBorderedSection />
        <TransactionSidebarFooterButton onViewEntireTransaction={onViewEntireTransaction} />
        {children}
        <Button
          iconRight="pencil"
          onClick={onRequestOpenManageSegments}
          disabled={transactionTaggingDisabled}
        >
          Manage Tags
        </Button>
      </React.Fragment>
    </Grid>
  );
}
